import { useEffect, useState } from "react";

const useFacebook = ({
  appId = process.env.REACT_APP_FACEBOOK_APP_ID,
  version = "v8.0",
  autoLogAppEvents = true,
  xfbml = true,
  cookie = true,
  debug = false,
  lang = "en_GB"
} = {}) => {
  const [isFacebookReady, setFacebookReady] = useState(false);

  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId,
        autoLogAppEvents,
        cookie,
        xfbml,
        version
      });

      setFacebookReady(true);
    };

    (function (d, s, id) {
      if (d.getElementById(id)) {
        setFacebookReady(true);
        return;
      }

      const fjs = d.getElementsByTagName(s)[0];
      const js = d.createElement(s);
      js.id = id;
      js.src = `https://connect.facebook.net/${lang}/sdk${
        debug ? "/debug" : ""
      }.js`;
      js.async = 1;
      js.defer = 1;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, [appId, version, autoLogAppEvents, xfbml, cookie, debug, lang]);
  return { isFacebookReady };
};

export default useFacebook;
